<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR ESTADO ECONÓMICO</h1>
            <div class="title-lists">
                {{ selectedSocioEconomic?.outsider?.identificationCode }} -
                {{ selectedSocioEconomic?.outsider?.name }}
                {{ selectedSocioEconomic?.outsider?.lastName }}
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="editsocioEconomicForm" (ngSubmit)="updatesocioEconomic()">
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Religión</mat-label>
                            <mat-select matInput placeholder="Religión" formControlName="religion">
                                <mat-option *ngFor="let religion of religion" [value]="religion.value">
                                    {{religion.value}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('religion')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Estado civil</mat-label>
                            <mat-select matInput placeholder="Estado civil" formControlName="civilianStatus">
                                <mat-option *ngFor="let c of civilStatus" [value]="c.value">{{ c.value }}</mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('civilianStatus')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Tipo de discapacidad</mat-label>
                            <mat-select multiple placeholder="Tipo de discapacidad" formControlName="disability">
                                <mat-option *ngFor="let l of disabilityTypes" [value]="l.value">{{ l.value
                                    }}</mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('disability')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Orientación sexual</mat-label>
                            <mat-select matInput placeholder="Orientación sexual" formControlName="gender">
                                <mat-option *ngFor="let o of sexualOrientation" [value]="o.value">{{ o.value }}</mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('gender')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Grupo cultural o étnico</mat-label>
                            <mat-select matInput placeholder="Grupo cultural o étnico" formControlName="culturaEthnic">
                                <mat-option *ngFor="let etnias of ethnic" [value]="etnias.value">
                                    {{ etnias.value }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('culturaEthnic')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Fuente de ingresos</mat-label>
                            <input matInput placeholder="Fuente de ingresos" formControlName="sourceIncome"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('sourceIncome')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>¿Cómo los obtiene?</mat-label>
                            <input matInput placeholder="¿Cómo los obtiene?" formControlName="sourceIncomeMethod"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('sourceIncomeMethod')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                     <div class="column-md-4 column-lg-6 column-sm-12">
                        <app-search-select [label]="'Lugar donde labora'" [placeholder]="'Lugar donde labora'"
                            [preloadedList]="locations" [displayFnFn]="displayFn" [identifierFn]="idFn"
                            formControlName="placeWork">
                        </app-search-select>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Número de hijos</mat-label>
                            <input type="number" matInput placeholder="Número de hijos" formControlName="qtyChildren"
                                rows="3" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('qtyChildren')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="isHeadOfHousehold">¿Es cabeza de
                                hogar?</mat-checkbox>
                        </section>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="isConflictVictim">¿Es víctima del
                                conflicto armado?</mat-checkbox>
                        </section>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="hasProtectionScheme">Tiene esquema de
                                seguridad</mat-checkbox>
                        </section>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="isLandOwner">Posee tierra</mat-checkbox>
                        </section>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12"
                        *ngIf="editsocioEconomicForm.get('isLandOwner')?.value">
                        <mat-form-field appearance="outline">
                            <mat-label>Área del terreno</mat-label>
                            <input type="number" matInput placeholder="Área del terreno" formControlName="landArea"
                                rows="3" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editsocioEconomicForm
                                        .get('landArea')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12"
                        *ngIf="editsocioEconomicForm.get('isLandOwner')?.value">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="ownsLand">El terreno es
                                propio</mat-checkbox>
                        </section>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                </button>
                <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
                    <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                </button>
            </form>
        </div>
    </div>
</div>
